import React from "react";
import "./DesignDescription.css";

function clean(value) {
  if (value === null || value === undefined) return "";

  const text = String(value).trim();

  return ["", "null", "undefined", "n/a", "-"].includes(text.toLowerCase())
    ? ""
    : text;
}

export default function DesignDescription({
  design,
  concepts = [],
  variant = "free",
}) {
  if (!design) return null;

  const isPaid = variant === "paid";

  const code = clean(design.design_code);
  const category = clean(design.category);
  const stitches = clean(design.stitch);
  const area = clean(design.area);
  const height = clean(design.height);
  const width = clean(design.width);
  const colours = clean(design.color);
  const details = clean(design.details);

  const rawPrice = clean(design.price);
  const price = Number(rawPrice.replace(/,/g, ""));

  const formattedPrice =
    rawPrice && Number.isFinite(price) && price >= 0
      ? `₹${price.toLocaleString("en-IN")}`
      : "";

  const conceptIds = Array.isArray(design.concepts_array)
    ? design.concepts_array
    : [];

  const conceptNames = [
    ...new Set(
      conceptIds
        .map((id) =>
          clean(
            concepts.find((item) => String(item.id) === String(id))
              ?.concept_name
          )
        )
        .filter(Boolean)
    ),
  ];

  const overview = [
    `Explore this ${
      isPaid ? "embroidery design offered for sale" : "free embroidery design"
    }${code ? `, code ${code}` : ""}${
      category ? `, listed in the ${category} category` : ""
    }.`,
    conceptNames.length
      ? `The listed design concepts are ${conceptNames.join(", ")}.`
      : "",
    isPaid && formattedPrice
      ? `The listed price is ${formattedPrice}.`
      : "",
    "Review the preview and specifications to assess whether the design matches your project.",
  ]
    .filter(Boolean)
    .join(" ");

  const specifications = [
    stitches ? `The listed stitch count is ${stitches}.` : "",
    area ? `The design area is listed as ${area}.` : "",
    height ? `The listed height is ${height}.` : "",
    width ? `The listed width is ${width}.` : "",
    colours ? `The listed colour count is ${colours}.` : "",
   
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section
      className="design-description"
      aria-label="Embroidery design description"
    >
      <span className="design-description__label">
        {isPaid ? "DESIGN PURCHASE GUIDE" : "DESIGN OVERVIEW"}
      </span>

      <h2>
        About this embroidery design{code ? ` — ${code}` : ""}
      </h2>

      <p>{overview}</p>

      <h3>Design specifications</h3>
      <p>{specifications}</p>

      {details && (
        <>
          <h3>Additional design details</h3>
          <p className="design-description__details">{details}</p>
        </>
      )}

      <h3>
        {isPaid ? "Check before purchasing" : "Check before stitching"}
      </h3>

      <p>
        {isPaid
          ? "Before purchasing, confirm the design dimensions, measurement units, included files, and EMB version with the seller. "
          : "Before stitching, confirm the design dimensions, measurement units, and EMB version. "}
        Check that your embroidery software can open the supplied file
        and that the design fits your machine’s hoop. You may need to
        export the EMB file to the stitch format supported by your machine.
      </p>

      <h3>Prepare a stitching sample</h3>

      <p>
        Open the file in compatible embroidery software and review the
        stitch sequence, colour changes, density, and trims. Test the
        design on a sample of your intended fabric using suitable
        thread, needle, and stabilizer. Check alignment, thread breaks,
        and puckering before stitching the final item.
      </p>

      {isPaid && (
        <>
          <h3>Confirm purchase and usage terms</h3>
          <p>
            Confirm how the file will be delivered, whether editing
            support is included, and what refund terms apply. Ask
            whether the licence permits your intended use, including
            embroidery on products for sale.
          </p>
        </>
      )}

      {/* <p className="design-description__note">
        {isPaid
          ? "Purchasing a design does not automatically grant permission to resell or redistribute its digital files. Review the seller’s licence terms."
          : "A free download does not automatically grant permission to resell or redistribute its digital files. Review the supplied usage terms."}
      </p> */}
    </section>
  );
}